import { render, staticRenderFns } from "./ComplaintList.vue?vue&type=template&id=bd5f95e2&scoped=true"
import script from "./ComplaintList.vue?vue&type=script&lang=js"
export * from "./ComplaintList.vue?vue&type=script&lang=js"
import style0 from "./ComplaintList.vue?vue&type=style&index=0&id=bd5f95e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5f95e2",
  null
  
)

export default component.exports